import { fetchConToken } from "../helpers/fetch";


//Este service no se usa ya que se hizo toda la funcionalidad con fetch
const FormulariosMiOspedycService = {

    //Categorias
    getCategoriasFormularios : () => {
        return fetchConToken(`MiOspedyc/CategoriaFormulario`, {}, 'GET')
    },
    getCategoriasFormulariosPorId : (data) => {
        return fetchConToken(`MiOspedyc/CategoriaFormulario/${data.idCategoriaFormularios}`, {}, 'GET')
    },
    crearCategoriaFormulario: (data) => {
        return fetchConToken(`MiOspedyc/CategoriaFormulario`, data, "POST")
      },
    guardarCategoriaFormulario: (data) => {
        return fetchConToken(`MiOspedyc/CategoriaFormulario/${data.idFormulario}`, data, "PUT")
      },
    
    //Formularios
    getFormularios: () => {
        return fetchConToken(`MiOspedyc/FormulariosMiOspedyc`, {}, 'GET')
    },

    getFormulariosPorCategoria: () => {
        return fetchConToken(`MiOspedyc/FormulariosMiOspedyc/PorCategoria`, {}, 'GET')
    },

    crearFormularioMiOspedyc: (data) => {
        return fetchConToken(`MiOspedyc/FormulariosMiOspedyc`, data, "POST")
    },

    guardarFormularioMiOspedyc: (id, data) => {
        return fetchConToken(`MiOspedyc/FormulariosMiOspedyc/CargarArchivo/${id}`, data, "POST", {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    actualizarFormulario: (id, data) => {
        return fetchConToken(`MiOspedyc/FormulariosMiOspedyc/${id}`, data, "PUT")
    },

    eliminarFormulario: (id) => {
        return fetchConToken(`MiOspedyc/FormulariosMiOspedyc/${id}`, "DELETE")
    }


}

export {FormulariosMiOspedycService as default}